<template>
  <modal
    name="openTemplate"
    transition="nice-modal-fade"
    :pivotY="0.3"
    :classes="[]"
    :clickToClose="false"
    @before-open="beforeOpen"
    @opened="isShow = true;"
    @closed="isShow = false;"
  >
    <div class="container">
      <div class="content">
        <span>确认添加模板后将会保存现有项目，并在当前页加载新的模板数据,请确认操作?</span>
      </div>
      <div class="footer">
        <div
          class="button button--primary button-confirm"
          @click="confirm"
        >确定</div>
        <div
          class="button button--primary button-cancel"
          @click="cancel"
        >取消</div>
      </div>
      <div
        class="close-btn"
        @click="hide()"
      >
        <i class="icon-popup-close"></i>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      waiting: false,
      templateId: "",
      isShow: false
    };
  },
  created () {
    this.$bus.on("saveWorks.completed", () => {

    });
  },
  methods: {
    onSaveCompleted () {
      if (!this.isShow) {
        return;
      }
      let {
        origin,
        pathname
      } = window.location;
      this.waiting = false;
      this.hide();

      window.onbeforeunload = null;
      window.location.assign(
        origin + pathname + "?template=" + this.templateId
      );
    },
    beforeOpen (ev) {
      this.templateId = ev.params.id;
    },
    hide () {
      if (this.waiting) {
        return;
      }
      this.$modal.hide("openTemplate");
    },
    confirm () {
      if (this.waiting) {
        return;
      }
      this.waiting = true;
      this.$bus.emit("save", {
        onCompleted: () => {
          this.onSaveCompleted();
        }
      });
      this.$bus.emit("openTemplate.confirm");
      this.$analysis(
        "resource_area,click_confirm_insert_template,素材资源区_点击_确定添加_模板"
      );
    },
    cancel () {
      this.$bus.emit("tellPayPanel", "isPaySuccess", false);
      this.hide();
      this.$analysis(
        "resource_area,click_cancel_insert_template,素材资源区_点击_取消添加_模板"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 420px;
  height: 210px;
  margin: auto;
  padding-top: 48px;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  text-align: center;
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  min-height: 44px;
  padding: 0 30px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;

  > div:nth-of-type(1) {
    margin-right: 25px;
  }
}

.button {
  width: 160px;
  height: 40px;
  border-radius: 8px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}

.button-cancel {
  background-color: #eaeaf6;
  border-color: #eaeaf6;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/openTemplate.vue